module.exports = __webpack_public_path__ + "static/media/arrow-right-calendar.2c6e2348.svg";